import React from "react";

const WithElement = ({ children, ...props }) =>
  React.createElement(children, { ...props });
export default WithElement;
